/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RequestPropertyChangeDto { 
    id?: number;
    tenantId?: number;
    entityName?: string | null;
    propertyName?: string | null;
    oldValue?: string | null;
    newValue?: string | null;
    entityRank?: number;
    entityCount?: number;
    requestId?: number;
}

